import React from 'react';
import { useMutation, useQuery } from '@apollo/client';
import {
  GET_JOB_ISOLATIONS,
  LINK_ISOLATION_JOBS,
  UPDATE_ISOLATION,
} from '../../../graph-queries/tar/isolation';
import { TIsolation } from '../../../lib/types';
import AspectsTable from '../AspectsTable/AspectsTable';
import IsolationForm from '../IsolationForm/IsolationForm';
import { columns } from '../../pages/Isolations/Isolations';
import classes from './JobAspects.module.scss';
import { useParams } from 'react-router-dom';
import { useHasTarAdminAccess, useHasUserAccess } from '../../../lib/util/auth';

const JobIsolations: React.FC = () => {
  const hasUserAccess = useHasUserAccess();
  const hasTarAdminAccess = useHasTarAdminAccess();
  const { jobId: param } = useParams();
  const jobId = parseInt(param || '-1');
  const { data, loading } = useQuery(GET_JOB_ISOLATIONS, {
    variables: { jobId },
  });
  const [updateIsolation] = useMutation(UPDATE_ISOLATION, {
    refetchQueries: [GET_JOB_ISOLATIONS],
  });
  const [linkIsolationJobs] = useMutation(LINK_ISOLATION_JOBS, {
    refetchQueries: [GET_JOB_ISOLATIONS],
  });

  const onEditSubmit = (isolation: TIsolation) => {
    const { updatedBy, updatedAt, tarJobs, ...input } = isolation;
    return updateIsolation({ variables: { input } });
  };

  const onLinkSubmit = (selection: TIsolation[], jobIds: number[]) => {
    return Promise.all(
      selection.map((isolation) =>
        linkIsolationJobs({
          variables: {
            isolationId: isolation.isolationId,
            jobIds: jobIds,
          },
        })
      )
    );
  };

  return (
    <AspectsTable<TIsolation>
      aspectName="isolation"
      data={(data?.isolationsByJobId as unknown as TIsolation[]) || []}
      onLinkSubmit={onLinkSubmit}
      columns={columns}
      renderEditForm={(onClose, defaultValue) => (
        <IsolationForm
          defaultValues={defaultValue}
          onSubmit={onEditSubmit}
          onClose={onClose}
          type={'edit'}
        />
      )}
      creationDisabled={!hasUserAccess}
      getRowMutationDisabled={(_row) => !hasUserAccess}
      getRowDeletionDisabled={(_row) => !hasTarAdminAccess}
      hideSelectionColumn
      renderBare
      title={<div className={classes.title}>Isolations</div>}
    />
  );
};

export default JobIsolations;
